const BrowserStorageAccessor = () => ({
  local: {
    get: key => localStorage.getItem(key),
    set: (key, value) => localStorage.setItem(key, value),
    remove: key => localStorage.removeItem(key)
  },
  session: {
    get: key => sessionStorage.getItem(key),
    set: (key, value) => sessionStorage.setItem(key, value),
    remove: key => sessionStorage.removeItem(key)
  }
});

export default BrowserStorageAccessor;
